
import SmokeParticle from './SmokeParticle';

class SmokeStream extends PIXI.Container {
  constructor(pX, pY, baseAlpha, strength) {
    super();

    // vars
    this.pX = pX;
    this.pY = pY;
    this.baseAlpha = baseAlpha;
    this.strength = strength;
    this.puffs = [];

    // init
    this.init();
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  init() {
    // props
    this.x = this.pX;
    this.y = this.pY;

    // puffs
    for (let i = 0; i < this.strength; i += 1) {
      this.puffs.push(new SmokeParticle(this, 260, this.baseAlpha));
    }

    // loop
    aScene.signals.loopCall.add(this.loopUp, this);
    // init update
    this.loopUp();
  }

  // --------------------------------------------------------------
  // Loop
  // --------------------------------------------------------------

  loopUp() {
    if (aScene.sceneManager.sceneState !== 1) {
      for (let i = 0; i < this.puffs.length; i += 1) {
        this.puffs[i].lUp();
      }
    }
  }
}

export default SmokeStream;



// WEBPACK FOOTER //
// ./src/js/scene/parts/town/parts/SmokeStream.js